import { createStore, applyMiddleware } from "redux";
import { persistStore } from "redux-persist";
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";

let middleware;

if (process.env.NODE_ENV === "development") {
  middleware = [thunk];
  middleware.push(...middleware);
} else {
  middleware = [thunk];
}
const composedEnhancer = composeWithDevTools(
  applyMiddleware(...middleware)
)

export const store = createStore(rootReducer, composedEnhancer);

export const persistor = persistStore(store);

// eslint-disable-next-line import/no-anonymous-default-export
export default { store, persistor };
